import React, {
  useCallback, useMemo, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Grid, Form, Input, Button, Validation,
} from 'framework-ui-components';
import SuccessoIcon from 'framework-ui-components/Components/Icons/SuccessoIcon';
import ErroreIcon from 'framework-ui-components/Components/Icons/ErroreIcon';
import Actions from '../Actions';
import AccountIcon from '../Icons/AccountIcon';
import { getParams } from '../Utils';

const { Row } = Grid;
const { Col } = Grid;

Validation.register(
  'token',
  (x, y) => {
    if (x.length > 0 && (x.length !== 8)) {
      return true;
    }
    return false;
  },
  { message: 'Il codice di sicurezza inserito non è valido' },
);

Validation.register(
  'complessitaPassword',
  (x, y) => {
    if (!x) {
      return false;
    } if (!/\d.*\d.*/.test(x)) {
      return true;
    } if (!/([A-Z])/.test(x)) {
      return true;
    } if (!/([a-z])/.test(x)) {
      return true;
    } if (!/[^A-Za-z0-9]/.test(x)) {
      return true;
    } if (x.length < 8) {
      return true;
    }
    return false;
  },
  { message: 'La password non rispetta le caratteristiche sotto elencate' },
);

const ResettaPassword = ({ applicationStyle }) => {
  const refRecuperaPasswordForm = useRef();

  const {
    referer, username, mailRecupero, linkContatti,
  } = getParams(window.location.href);

  const [formState, setFormState] = useState({
    CodiceFiscale: username,
  });
  const [erroreResetPassword, setErroreResetPassword] = useState(false);
  const [resetPasswordAvvenuto, setResetPasswordAvvenuto] = useState(false);

  const verificaPasswordCoincidenti = useCallback(() => (!formState.ConfermaPassword || formState.NuovaPassword !== formState.ConfermaPassword
    ? 'La due password digitate non coincidono' : null), [formState.ConfermaPassword, formState.NuovaPassword]);

  const reimpostaPassword = useCallback(() => {
    if (formState.NuovaPassword !== formState.ConfermaPassword || !refRecuperaPasswordForm.current.isValid) {
      return null;
    }

    return Actions.ResettaPassword(
      formState.CodiceFiscale,
      formState.NuovaPassword,
      formState.Token,
    ).then(
      (res) => {
        if (res.Success) {
          setErroreResetPassword(false);
          setResetPasswordAvvenuto(true);
        } else {
          setErroreResetPassword('I dati forniti non sono corretti');
        }
      },
      (res) => {
        setErroreResetPassword('Errore nel reset della password');
      },
    );
  }, [formState.CodiceFiscale, formState.ConfermaPassword, formState.NuovaPassword, formState.Token]);

  const handleKeyPress = useCallback((e) => {
    if (e.key === 'Enter') {
      reimpostaPassword();
    }
  }, [reimpostaPassword]);

  const renderForm = useMemo(() => (
    <Form ref={refRecuperaPasswordForm} onChange={((x) => setFormState((old) => ({ ...old, ...x })))} stato={formState}>
      <div className="resettaPassword__intro">
        <h3>Ci siamo quasi!</h3>
        {mailRecupero
          ? (
            <span>
              Ti abbiamo inviato un&apos;e-mail all&apos;indirizzo <strong>{mailRecupero}</strong><br /><br />
              Non la trovi? Assicurati che non sia nella posta indesiderata.<br /><br />
              Per modificare la password devi inserire il codice di sicurezza che hai ricevuto nel messaggio e-mail che ti abbiamo mandato.<br /><br />
            </span>
          ) : (
            <span>
              Per modificare la password devi inserire il codice di sicurezza che hai ricevuto nel messaggio e-mail che ti abbiamo mandato.
              <br /><br /><br /><br />
            </span>
          )}
      </div>
      <Grid>
        <Row>
          <Col md="6" xs="12">
            <Input
              autoFocus
              title="Codice di sicurezza"
              name="Token"
              validations={['required', 'token']}
              onKeyPress={handleKeyPress}
              className="spaceRight"
            />
          </Col>
          <Col md="6" xs="12">
            <Input
              title="Codice fiscale"
              name="CodiceFiscale"
              validations={['required']}
              onKeyPress={handleKeyPress}
              spellCheck="false"
              className="spaceLeft"
            />
          </Col>
        </Row>
        <Row>
          <Col md="6" xs="12">
            <Input
              title="Nuova password"
              name="NuovaPassword"
              type="password"
              className="spaceRight"
              onKeyPress={handleKeyPress}
              validations={[
                'required',
                'complessitaPassword']}
            />
          </Col>
          <Col md="6" xs="12">
            <Input
              title="Conferma password"
              name="ConfermaPassword"
              type="password"
              className="spaceLeft"
              onKeyPress={handleKeyPress}
              validations={[
                'required',
                verificaPasswordCoincidenti]}
            />
          </Col>
        </Row>
      </Grid>
      <div className="accountsForm__actions">
        <br />
        <span className="resettaPassword__nota">
          <strong>NOTA</strong>: La password deve essere lunga almeno 8 caratteri e contenere 2 numeri, 1 lettera maiuscola,
          1 minuscola e 1 carattere speciale.
        </span>
        <br /><br />
        <div className="login__btnContainer">
          <Button
            primary
            className="resettaPassword__button"
            disabled={!refRecuperaPasswordForm.current || !refRecuperaPasswordForm.current.isValid}
            onClick={reimpostaPassword}
          >
            Modifica Password
          </Button>
          {erroreResetPassword && (
            <div className="effettuaLogin__errore">
              <ErroreIcon /><span>{erroreResetPassword}</span>
            </div>
          )}
        </div>
        <br />
      </div>
    </Form>
  ), [erroreResetPassword, formState, handleKeyPress, mailRecupero, reimpostaPassword, verificaPasswordCoincidenti]);

  const accedi = useCallback(() => {
    window.location.href = referer;
  }, [referer]);

  const renderResetPasswordAvvenuto = useMemo(() => (
    <div className="resettaPassword__okContainer">
      <div className="resettaPassword__okImage">
        <SuccessoIcon />
      </div>
      <strong className="resettaPassword__okText">
        Password modificata con successo
      </strong><br /><br />
      <Button primary onClick={accedi}>Accedi</Button><br />
      <br /><br />
      <span>Per assistenza consulta la pagina dei <a href={linkContatti} target="_blank" rel="noopener noreferrer">Contatti</a></span>
    </div>
  ), [accedi, linkContatti]);

  return (
    <div className="account__col account__resettaPassword">
      <div className="accounts__wrapper">
        <div className="accounts__container">
          <div className="accounts__header">
            {applicationStyle.logo || <AccountIcon />}
          </div>
          {resetPasswordAvvenuto ? renderResetPasswordAvvenuto : renderForm}
        </div>
      </div>
    </div>
  );
};

ResettaPassword.propTypes = {
  applicationStyle: PropTypes.shape({
    logo: PropTypes.element,
  }).isRequired,
};

export default ResettaPassword;
